import { createContext } from 'preact'

const SeamlyActivityEventContext = createContext<(() => void) | null>(null)

export default SeamlyActivityEventContext
